import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Accordion } from './ui/Accordion';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon } from 'lucide-react';
export function ClosingSection() {
  const faqs = [{
    question: '¿Realmente funciona en 15 minutos?',
    answer: "Sí, porque no es limpieza profunda, es triaje visual efectivo. Te enseñamos a enfocarte estratégicamente en lo que el ojo humano percibe como 'limpio' al entrar a una habitación."
  }, {
    question: '¿Tengo que comprar máquinas caras?',
    answer: 'No, en absoluto. El método se basa en usar lo que ya tienes de forma más inteligente y te damos una lista de solo 5 esenciales económicos que puedes encontrar en cualquier supermercado.'
  }, {
    question: '¿Sirve si tengo niños pequeños?',
    answer: 'Especialmente si tienes niños. Sabemos que el desorden se multiplica, por eso el sistema incluye tácticas específicas sobre cómo gestionar el caos infantil sin volverte loca.'
  }, {
    question: '¿Es un libro físico?',
    answer: 'Es una guía digital en formato PDF de alta calidad. La recibes al instante en tu correo electrónico tras la compra, para que puedas empezar a aplicar el método hoy mismo desde tu teléfono o tablet.'
  }];
  return <section className="py-20 bg-white relative" data-id="element-32">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-33">
        {/* Proof / Believability */}
        <FadeIn data-id="element-34">
          <div className="text-center mb-20" data-id="element-35">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-olive mb-6" data-id="element-36">
              Imagina tu próximo fin de semana...
            </h2>
            <p className="text-xl text-olive/80 leading-relaxed max-w-2xl mx-auto" data-id="element-37">
              En los próximos 7 días, dejarás de sentir ese peso en los hombros
              al entrar a tu sala. No porque la casa sea perfecta, sino porque
              tendrás el sistema para ponerla bajo control en el tiempo que
              tarda en colarse una cafetera.
            </p>
          </div>
        </FadeIn>

        {/* FAQ Section */}
        <div className="mb-24" data-id="element-38">
          <FadeIn delay={100} data-id="element-39">
            <h3 className="text-2xl font-bold text-center text-olive mb-10" data-id="element-40">
              Preguntas Frecuentes
            </h3>
            <Accordion items={faqs} data-id="element-41" />
          </FadeIn>
        </div>

        {/* Offer Block */}
        <FadeIn delay={200} data-id="element-42">
          <div id="offer" className="bg-light-terra/40 rounded-[2.5rem] p-8 md:p-12 text-center border-2 border-terra/20 shadow-xl relative overflow-hidden" data-id="element-43">
            {/* Decorative circles */}
            <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/2 w-64 h-64 bg-white/40 rounded-full blur-2xl pointer-events-none" data-id="element-44"></div>
            <div className="absolute bottom-0 left-0 translate-y-1/2 -translate-x-1/2 w-64 h-64 bg-terra/10 rounded-full blur-2xl pointer-events-none" data-id="element-45"></div>

            <div className="relative z-10" data-id="element-46">
              <h2 className="text-3xl md:text-4xl font-bold text-olive mb-4" data-id="element-47">
                Recupera tu derecho a descansar en casa.
              </h2>
              <p className="text-lg text-olive/80 mb-8 max-w-xl mx-auto" data-id="element-48">
                Obtén el sistema completo "Clean Slate Latina". Olvida la culpa
                y el pánico por las visitas inesperadas.
              </p>

              <div className="mb-8" data-id="element-49">
                <span className="block text-sm font-bold text-terra uppercase tracking-wider mb-2" data-id="element-50">
                  Precio Especial
                </span>
                <div className="flex items-center justify-center gap-4" data-id="element-51">
                  <span className="text-2xl font-serif text-olive/40 line-through" data-id="element-52">
                    $17.00
                  </span>
                  <span className="text-6xl font-serif font-bold text-olive" data-id="element-53">
                    $6<span className="text-2xl text-olive/60" data-id="element-54">.39</span>
                  </span>
                </div>
                <span className="inline-block mt-2 bg-terra/15 text-terra font-bold text-sm px-3 py-1 rounded-full" data-id="element-55">
                  Ahorra 62%
                </span>
                <span className="block text-sm text-olive/60 mt-2" data-id="element-56">
                  USD • Pago único
                </span>
              </div>

              <CTAButton href="https://temptbeuty.com/cart/56849035231392:1" className="w-full md:w-auto text-lg px-12 py-5 mb-6" data-id="element-57">
                ¡SÍ, QUIERO MI CASA BAJO CONTROL AHORA!
              </CTAButton>

              <div className="flex items-center justify-center text-olive/60 text-sm font-medium" data-id="element-58">
                <ShieldCheckIcon className="w-5 h-5 mr-2 text-sage" data-id="element-59" />
                Compra 100% segura. Acceso inmediato tras el pago.
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}